module.exports = __webpack_public_path__ + "static/wgat-stacked-f6fac8656bffa8b9664925bae9cbc90a.svg";